<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">待处理预警</div>
        <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
          <el-form-item label="预警级别">
            <el-select v-model="AlerteLevel" placeholder="请选择">
              <el-option
                v-for="item in AlerteLevelArr"  
                :key="item.ItemKey"
                :label="item.Description"
                :value="item.Extend1"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="求助预警类型">
            <el-select v-model="AlertType" placeholder="请选择">
              <el-option
                v-for="item in AlertTypeArr"
                :key="item.ItemKey"
                :label="item.Description"
                :value="item.Extend1"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="" class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
          <!-- <el-button size="mini" @click="onbatchDel">删 除</el-button> -->
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
        <div class="zj-table-container">
          <el-table
            :data="tableData"
            ref="multipleTable"
            @selection-change="selectionChange"
            border
            style="width: 100%"
            fixed
          >
             <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
            <el-table-column prop="AlerteLevel" label="预警级别" width="80">
               <template slot-scope="scope">
                <span class="fontRed" v-if="scope.row.AlerteLevel == '10'">红色预警</span>
                <span class="fontOrange" v-else-if="scope.row.AlerteLevel == '7'">橙色预警</span>
                <span class="fontYellow" v-else-if="scope.row.AlerteLevel == '5'">黄色预警</span>
                <span class="fontBlue" v-else-if="scope.row.AlerteLevel == '3'">蓝色预警</span>
              </template>
            </el-table-column>
            <el-table-column prop="Content" label="预警信息" width="260">
            </el-table-column>
            <el-table-column prop="AlertType" label="预警类型" :formatter="getAlarmTypeShow" width="130"></el-table-column>
            <el-table-column prop="SourceDesc" label="预警来源"  width="90"></el-table-column>
            <el-table-column prop="Location" label="预警地点"></el-table-column>
            
            <el-table-column prop="BeginDate" label="预警时间" :formatter="formatDate" width="180">
              <!-- <template slot-scope="scope">
                {{scope.row.BeginDate|formatDatSingle}}~{{scope.row.EndDate|formatDatSingle}}
              </template> -->
            </el-table-column>
       
            <el-table-column prop="Phone" label="联系方式"  width="120"></el-table-column>
            <el-table-column prop="ProcessStatus" label="处理状态"  width="80">
              <template slot-scope="scope">
                <span v-if="scope.row.ProcessStatus == '0'">待处理</span>
                <span v-else-if="scope.row.ProcessStatus == '2'">已完结</span>
              </template>
            </el-table-column>
     
            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.$index,scope.row)" type="text" size="small">确认处理</el-button>
                
              </template>
            </el-table-column>
          </el-table>
        </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
export default {
  name: "SeekHelpAlarmList",
  controller: "UI",
  action: "SeekHelpAlarmList",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      AlertType: "13",//预警类型
      AlertTypeArr:[],
      AlerteLevel:null,//预警级别
      AlerteLevelArr:[],
   
    };
  },
  filters:{
     formatDatSingle(data) {
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format('yyyy-MM-dd hh:mm:ss');
    }
  },
  created: function() {
    //预警级别
    this.alarmLevel();
    //预警类型
    this.getAlarmType();
  },
  mounted: function() {
    this.search();
    this.logInfo.ActionName = "待处理预警查询";
    this.logInfo.LogMessage = "待处理预警查询";
    this.logInfo.ModuleName = "紧急求助";
    this.logInfo.PageName = "待处理预警列表";
    this.addOperationLog();
  },
  methods: {
    getAlarmTypeShow(row,column){
      let data = row[column.property];
      console.log(data)
      if (data == null || data == "") {
        return null;
      }
     let arr = this.AlertTypeArr
     for(let i=0;i<arr.length;i++){
       if(arr[i].Extend1==data){
         return arr[i].Description
       }
     }
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
    },
    search() {
      let searchInfo = {

          PageSize: this.pageSize,
          PageIndex: this.currentPage,
          AlertType: this.AlertType,
          AlerteLevel: this.AlerteLevel,
          ProcessStatus:"" //0
      };
      new MyApis.SeekHelpApi()
        .GetAlertItemPagingList(searchInfo)
        .then(r => {
          //console.log("1");
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch(e => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    clearsearch() {
      this.AlertType = "";
      this.AlerteLevel = "";
    },
    //基础数据绑定
    alarmLevel() {
      //预警级别
      this.config
        .getUValue("BusinessAlarm:AlertLevel", "")
        .then(d => {
          console.log("预警级别")
          console.log(d)
          this.AlerteLevelArr = d.JValue;
        })
        .catch(e => console.error(e));
    },
     getAlarmType() {
      //预警类型
      this.config
        .getUValue("BusinessAlarm:AlertType", "")
        .then(d => {
          console.log("预警类型")
          console.log(d)
          this.AlertTypeArr = d.JValue;
        })
        .catch(e => console.error(e));
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
    },
    //查看详细
    handleClick(index, row) {
      this.$router.push({
        path: "/plugin/seekHelp/UI/SeekHelpAlarmInfo",
        query: {
          Id: row.Id,
          type: "search"
        }
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/seekHelp/UI/SeekHelpAlarmInfo",
        query: {
          type: "add"
        }
      });
    },
    //批量删除
    onbatchDel() {
      if (
        this.selectData != undefined &&
        this.selectData != null &&
        this.selectData.length > 0
      ) {
        this.$confirm("选中的数据将被永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            const selectData = this.selectData;
            const count = selectData.length;
            // 清除 所有勾选项
            this.$refs.multipleTable.clearSelection();
            if (count > 0) {
              new MyApis.SeekHelpApi()
                .DelItemList(selectData)
                .then(r => {
                  r = r.data.Data;
                  if (r) {
                    this.$message({
                      type: "success",
                      message: "删除成功!"
                    });
                  } else {
                    this.$message({
                      type: "error",
                      message: "删除失败!"
                    });
                  }
                  this.search();
                })
                .catch(e => {
                  console.log(e);
                });
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      } else {
        this.$message({
          type: "info",
          message: "未选中任何行！"
        });
      }
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          new MyApis.SeekHelpApi()
            .DelItem(row)
            .then(r => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!"
                });
              }
              this.search();
            })
            .catch(e => {
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    ConvertTranresourcesType(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      let levelstr=this.TranresourcesTypeDic[data];
      return   levelstr ;
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }

      return new Date(data).format('yyyy-MM-dd hh:mm:ss');
    }
  }
};
</script>
<style type="text/css">
  .fontRed{
    color: red;
  }
  .fontYellow{
    color: yellow;
  }
  .fontBlue{
    color: blue;
  }
  .fontOrange{
    color: orange;
  }
</style>